// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.6";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://25016218cf034e9c7347ba2760acfecc@o437709.ingest.us.sentry.io/4509373472768000',
  tracesSampleRate: 0.1,
  sampleRate: 0.25,
  replaysOnErrorSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  profileSessionSampleRate: 0,
  debug: false,
  integrations: [
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: 'system',
    }),
  ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
